import React, { useState } from 'react';
import { signInWithEmailAndPassword, sendPasswordResetEmail, signOut } from 'firebase/auth';
import { auth, db } from '../firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';
import './Login.css';

const Login = ({ setLoginError, loginError }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(loginError || ''); // Usar el error pasado por App
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [mode, setMode] = useState('login'); // 'login' o 'reset'

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        setLoginError(''); // Limpiar error global al intentar de nuevo
        setMessage('');
        try {
            const userCredential = await signInWithEmailAndPassword(auth, email, password);
            const user = userCredential.user;

            // Verificación adicional en Firestore
            const q = query(collection(db, 'usuarios'), where('email', '==', user.email));
            const querySnapshot = await getDocs(q);

            if (querySnapshot.empty) {
                // El usuario existe en Auth pero no en la colección 'usuarios'
                await signOut(auth);
                setLoginError('Usuario no registrado. Contacta al administrador.');
            } else {
                const userData = querySnapshot.docs[0].data();
                if (!userData.activo) {
                    // El usuario existe pero está inactivo
                    await signOut(auth);
                    setLoginError('Tu cuenta está desactivada. Contacta al administrador.');
                }
                // Si todo está bien, el onAuthStateChanged en App.js se encargará del resto.
            }
        } catch (err) {
            if (err.code === 'auth/user-not-found' || err.code === 'auth/wrong-password' || err.code === 'auth/invalid-credential') {
                setLoginError('Email o contraseña incorrectos.');
            } else {
                setLoginError('Error al iniciar sesión. Inténtalo de nuevo.');
            }
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const handlePasswordReset = async (e) => {
        e.preventDefault();
        if (!email) {
            setError('Por favor, ingresa tu dirección de email.');
            return;
        }
        setLoading(true);
        setError('');
        setLoginError('');
        setMessage('');
        try {
            await sendPasswordResetEmail(auth, email);
            setMessage('✅ Se ha enviado un correo para restablecer tu contraseña. Revisa tu bandeja de entrada.');
            setMode('login'); // Volver al login después de enviar
        } catch (err) {
            setError('Error al enviar el correo. Asegúrate de que el email sea correcto.');
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            {mode === 'login' ? (
                <form onSubmit={handleLogin} className="login-form">
                    <h2>Iniciar Sesión</h2>
                    <p className="login-subtitle">Bienvenido al Sistema de Información Comercial</p>
                    
                    {(error || loginError) && <p className="error-message">{error || loginError}</p>}
                    {message && <p className="success-message">{message}</p>}

                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Email"
                        required
                    />
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Contraseña"
                        required
                    />
                    <button type="submit" disabled={loading}>
                        {loading ? 'Iniciando...' : 'Ingresar'}
                    </button>
                    <div className="login-actions">
                        <button type="button" className="link-button" onClick={() => setMode('reset')}>
                            ¿Olvidaste tu contraseña?
                        </button>
                    </div>
                </form>
            ) : (
                <form onSubmit={handlePasswordReset} className="login-form">
                    <h2>Restablecer Contraseña</h2>
                    <p className="login-subtitle">Ingresa tu email para recibir un enlace de recuperación.</p>

                    {(error || loginError) && <p className="error-message">{error || loginError}</p>}

                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Email"
                        required
                    />
                    <button type="submit" disabled={loading}>
                        {loading ? 'Enviando...' : 'Enviar Correo'}
                    </button>
                    <div className="login-actions">
                        <button type="button" className="link-button" onClick={() => setMode('login')}>
                            &larr; Volver a Iniciar Sesión
                        </button>
                    </div>
                </form>
            )}
        </div>
    );
};

export default Login;